"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var units_1 = __importDefault(require("./constants/units"));
var en_US_1 = __importDefault(require("./constants/en-US"));
var vehicleMake_1 = __importDefault(require("./constants/vehicleMake"));
var routes_1 = require("./constants/routes");
var FAULTS = __importStar(require("./constants/faults"));
var modals_1 = __importDefault(require("./constants/modals"));
var env_1 = __importDefault(require("./constants/env"));
var ProxyApi_1 = __importDefault(require("./constants/ProxyApi"));
var types_1 = require("./constants/types");
var tooltip_1 = __importDefault(require("./constants/tooltip"));
exports.default = {
    SHARED_LOCALE_STRINGS: en_US_1.default,
    UNITS: units_1.default,
    VEHICLE_MAKE: vehicleMake_1.default,
    ROUTE_TABLE: routes_1.ROUTE_TABLE,
    FAULTS: FAULTS,
    MODAL_IDS: modals_1.default,
    ENV: env_1.default,
    PROXY_API: ProxyApi_1.default,
    SORT_ORDER: types_1.SORT_ORDER,
    TOOLTIPS: tooltip_1.default,
};
